import styled, { css } from 'styled-components';

export const Wrapper = styled.span<{ $size: number; $flipInRtl: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  font-size: ${({ $size }) => `${$size / 16}rem`};
  font-weight: initial;
  line-height: 1;
  color: var(--t-brand-fg-color);

  ${({ $flipInRtl }) =>
    $flipInRtl &&
    css`
      [dir='rtl'] & {
        transform: scaleX(-1);
      }
    `}

  [dir='rtl'] & .icon-arrow-right-external:hover::before,
  [dir='rtl'] & .icon-arrow-right-external:focus-visible::before,
  [dir='rtl'] & .icon-arrow-right-external.focus-visible::before {
    transform: rotate(45deg);
  }

  [dir='rtl'] & .icon-arrow-left-external:hover::before,
  [dir='rtl'] & .icon-arrow-left-external:focus-visible::before,
  [dir='rtl'] & .icon-arrow-left-external.focus-visible::before {
    transform: rotate(-45deg);
  }

  /* DUX-1153 Global Styles overrides:  .icon */
  .icon {
    width: 100%;
    height: 100%;
  }

  &.a-icon-branded {
    color: var(--t-non-interactive-accent-color);
  }

  &.a-icon-muted {
    color: var(--t-brand-alt-color);
  }
`;
